// 英文语言包
var enUS = {
    type: 'en_US',
    waterfall: {
        total: 'total',
    },
    calendar: {
        monthAbbr: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sept',
            'Oct',
            'Nov',
            'Dec',
        ],
        dayOfWeekAbbr: ['Sun', 'Mon', 'Tues', 'Wed', 'Thur', 'Fri', 'Sat'],
    },
};
export default enUS;
